import {
  CLEAR_RETURNS,
  SELECT_RETURN,
  SET_LOADING_RETURN_ID,
  SET_RETURNS,
  SET_SEARCH_RETURNS_ACTION,
  SET_SEARCH_RETURNS_QUERY,
  CLEAR_RETURNS_SEARCH_STATE,
} from '../../constants/returnsSearchActionTypes';

import dotProp from 'dot-prop-immutable';

const cleanSearchState = {
  selectedSearchAction: null,
  selectedSearchQuery: null,
};

const cleanTaskReturnState = {
  loadingReturnId: null,
  searchError: null,
};

export const defaultState = {
  returns: [],
  selectedReturn: {},
  ...cleanSearchState,
  ...cleanTaskReturnState,
};

const returnsSearch = (state = defaultState, action) => {
  switch (action.type) {
    case SET_RETURNS:
      return {
        ...state,
        returns: action.returns,
        searchError: null,
      };
    case SELECT_RETURN:
      return {
        ...state,
        selectedReturn: action.return,
        searchError: null,
      };
    case SET_LOADING_RETURN_ID:
      return dotProp.set(state, 'loadingReturnId', action.return_id);
    case SET_SEARCH_RETURNS_ACTION:
      return {
        ...state,
        selectedSearchAction: action.action,
        selectedSearchQuery: null,
        returns: [],
        ...cleanTaskReturnState,
      };
    case SET_SEARCH_RETURNS_QUERY:
      return dotProp.set(state, 'selectedSearchQuery', action.query);
    case CLEAR_RETURNS:
      return {
        ...state,
        returns: [],
        selectedReturn: {},
        searchError: null,
        loadingReturnId: null,
      };
    case CLEAR_RETURNS_SEARCH_STATE:
      return { ...defaultState };
    default:
      return state;
  }
};

export default returnsSearch;
